"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Text;
var L = require("leaflet");
var createjs = require("@caddigital/easeljs/lib/easeljs");
var mobile_1 = require("@caddigital/sok-ui/lib/utils/mobile");
var Rectangle_1 = require("./Rectangle");
var define = require("./define");
/**
 * TODO: REFACTOR THIS TO OWN FILE
 * convert latlng to point
 * */
var latlngToPoint = function (map, coords, pointCoordinate, zoom) {
    var p = map.project(pointCoordinate, zoom);
    var x = Math.round(p.x - coords.x);
    var y = Math.round(p.y - coords.y);
    // coords to tile space
    return new L.Point(x, y);
};
(createjs.Graphics.TextPrimitive = function (x, y, text) {
    this.x = x;
    this.y = y;
    this.text = text;
}).prototype.exec = function (ctx) {
    ctx.fillText(this.text, this.x, this.y);
};
(createjs.Graphics.Font = function (size, fontFamily, fontStyle, fontWeight, color) {
    this.fontSize = size;
    this.fontFamily = fontFamily;
    this.fontWeight = fontWeight;
    this.fontStyle = fontStyle;
    this.color = color;
}).prototype.exec = function (ctx) {
    ctx.font =
        this.fontWeight + ' ' + this.fontSize + 'px' + ' ' + this.fontFamily;
    ctx.fillStyle = this.color;
};
createjs.Graphics.prototype.drawText = function (x, y, text) {
    return this.append(new createjs.Graphics.TextPrimitive(x, y, text));
};
createjs.Graphics.prototype.setFont = function (size, fontFamily, fontStyle, fontWeight, color) {
    return this.append(new createjs.Graphics.Font(size, fontFamily, fontStyle, fontWeight, color));
};
function Text(map, latlng, text, font, fontSize, color, fontWeight, textAlign, textBaseLine) {
    var _this = this;
    createjs.Shape.call(this);
    this.font = font;
    this.text = text;
    this.fontSize = fontSize;
    this.fontWeight = fontWeight || 400;
    this.textAlign = textAlign || 'left';
    this.textBaseLine = textBaseLine || 'top';
    this._prepContext = function (ctx) {
        ctx.font = _this.fontSize * _this._scale + 'px ' + _this.font;
        ctx.textAlign = _this.textAlign || 'left';
        ctx.textBaseline = _this.textBaseLine || 'top';
        ctx.fillStyle = _this.fill || '#aaa';
        ctx.lineJoin = 'miter';
        ctx.miterLimit = 2.5;
        return ctx;
    };
    this.getMeasuredWidth = function (text) {
        var ctx = _this.tmpCanvas.getContext('2d');
        ctx.save();
        var w = _this._prepContext(ctx).measureText(text).width;
        return w;
    };
    this.getMeasuredLineHeight = function (character) {
        return _this.getMeasuredWidth(character) * 1.2;
    };
    this.getMetrics = function () {
        return {
            width: _this.getMeasuredWidth(_this.text),
            height: _this.getMeasuredLineHeight('M')
        };
    };
    this.tmpCanvas = document.createElement('canvas');
    this.tmpCanvas.width = this.tmpCanvas.height = 1;
    // center the coordinate
    var origin = map.getPixelOrigin();
    var zoom = map.getZoom();
    var crs = map.options.crs;
    var scale = crs ? crs.scale(zoom) : 0;
    var point = latlngToPoint(map, origin, latlng, map.getZoom());
    var measures = this.getMetrics();
    var width = measures.width;
    var height = measures.height;
    // Workaround for font awesome font size
    if (this.font === '"Font Awesome 5 Free"') {
        width *= 1.5;
        height *= 1.2;
    }
    var startPoint = point.add(new L.Point(width * scale * define.H_OFFSETS[this.textAlign], height * scale * define.V_OFFSETS[this.textBaseLine])); // point.add(new L.Point(width * define.H_OFFSETS[this.textAlign] * scale, ((height * define.V_OFFSETS[this.textBaseLine||'top']) * scale)))
    var boundStart = startPoint;
    var boundEnd = boundStart.add(new L.Point(width * scale, height * scale));
    var startCoord = map.layerPointToLatLng(boundStart);
    var endCoord = map.layerPointToLatLng(boundEnd);
    var originalBounds = new L.LatLngBounds([startCoord, endCoord]);
    Rectangle_1.default.call(this, map, originalBounds, color);
    this.measures = measures;
    this.lineHeight = measures.height;
    this._drawBoundingBox = function () {
        var g = _this.graphics;
        g.beginStroke(createjs.Graphics.getRGB(0, 0, 0, 0.3))
            .setStrokeStyle(1, 'round', 'bevel', 'round')
            .setStrokeDash([5, 5]);
        g.drawRect(_this._bounds.x, _this._bounds.y, _this._bounds.width, _this._bounds.height);
    };
    this._drawText = function () {
        var g = _this.graphics;
        var modifier = 0.45;
        var browserBasedX = (_this.width / 2) * _this._scale * modifier;
        if (_this.font === '"Font Awesome 5 Free"') {
            modifier = 0.45;
            if (mobile_1.isFirefox) {
                browserBasedX = 5 * _this._scale * modifier * -1;
            }
            if (mobile_1.isIE11) {
                browserBasedX = 3 * _this._scale * modifier * -1;
            }
        }
        g.beginStroke(createjs.Graphics.getRGB(0, 0, 0, 0.3));
        g.beginFill(_this.fill);
        g.setFont(_this.fontSize * _this._scale, _this.font, 'normal', _this.fontWeight, _this.fill);
        g.drawText(_this.x - browserBasedX, _this.y + (_this.height - (_this.lineHeight * _this._scale * modifier) / 2), _this.text);
    };
    this._draw = function (ctx) {
        _this.graphics.clear();
        if (define.DEBUGGING) {
            _this._drawBoundingBox();
        }
        _this.graphics.endStroke();
        _this._drawText();
        return true;
    };
    return this;
}
Text.prototype = new createjs.Shape();
